<template>
  <component
    v-model="model"
    :is="getComponent"
    :label="label"
    :name="name"
    :placeholder="placeholder"
    :type="type"
    :error="error"
    :options="options"
    :data="data"
    :config="config"
    :rows="rows"
    :min-rows="minRows"
    :max-rows="maxRows"
    :add-label="addLabel"
    :value-getter="valueGetter"
    :label-getter="labelGetter"
    :checked-label="checkedLabel"
    :unchecked-label="uncheckedLabel"
    :icon="icon"
    :title="title"
    :underlined="underlined"
    :inline="inline"
    :switch="isSwitch"
    :dropdown="dropdown"
    :position="position"
    :separator="separator"
    :disabled="disabled"
    :required="required"
    :disable-weekends="disableWeekends"
    :disable-passed-dates="disablePassedDates"
    :enable-limit="enableLimit"
    @input="emit('change', $event)"
    @change="emit('change', $event)"
    @file-change="emit('file-change', $event)"
    @debounce="emit('debounce', $event)"
    @submit="emit('submit', $event)"
  ></component>
</template>

<script>
export default {
  props: {
    value: [String, Array, Object, Boolean],
    component: {
      type: String,
      default: "input"
    },
    label: String,
    name: String,
    placeholder: String,
    checkedLabel: String,
    uncheckedLabel: String,
    icon: String,
    data: Array,
    config: Array,
    rows: [String, Number],
    minRows: Number,
    maxRows: Number,
    title: String,
    addLabel: String,
    type: String,
    options: Array,
    position: String,
    valueGetter: String,
    labelGetter: String,
    error: [String, Array],
    underlined: Boolean,
    inline: Boolean,
    switch: Boolean,
    dropdown: Boolean,
    separator: Boolean,
    required: Boolean,
    disabled: Boolean,
    disableWeekends: Boolean,
    disablePassedDates: Boolean,
    enableLimit: Boolean,
  },
  computed: {
    getComponent() {
      return `f3-${this.component}`;
    },
    isSwitch () {
      return this.switch
    },
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  methods: {
    emit (key, event) {
      this.$emit(key, event)
    }
  }
};
</script>
